import { CloudProductAvailability } from "@omni/types/api/store/cloud/shared/productAvailability.model";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { determineDeliveryTimeTranslationKey } from "@/utils/deliveryPromise";
import {
    getProductAvailabilityStatus,
    ProductAvailabilityStatus
} from "@/utils/productAvailability";

type StoreProductAvailabilityComponentProps = {
    productAvailability: CloudProductAvailability;
};

export const StoreProductAvailabilityComponent = ({
    productAvailability
}: StoreProductAvailabilityComponentProps) => {
    const { t } = useGranite();

    const tk = determineDeliveryTimeTranslationKey({
        deliveryPromiseType: productAvailability?.deliveryPromiseType,
        stockLevel: productAvailability?.stockLevel,
        realTimeStockAvailable: productAvailability?.realTimeStockAvailable,
        realTimeStock: productAvailability?.realTimeStock,
        deliveryTime: productAvailability?.deliveryTime
    });
    const deliveryTimeUnitTk = `product.deliveryPromise.timeUnits.${productAvailability?.deliveryTimeUnit}`;

    const productAvailabilityStatus =
        getProductAvailabilityStatus(productAvailability);

    let className: string = "";
    let icon: string = "";

    switch (productAvailabilityStatus) {
        case ProductAvailabilityStatus.InStock:
            className = "text-success";
            icon = "la-check";
            break;
        case ProductAvailabilityStatus.S2S:
            className = "";
            icon = "la-check";
            break;
        case ProductAvailabilityStatus.LowStock:
            className = "text-warning";
            icon = "la-check";
            break;
        case ProductAvailabilityStatus.NoStock:
            className = "text-danger";
            icon = "la-times";
            break;
    }

    return (
        <p className={cn(className, "tw:m-0")}>
            <i className={cn(`las ${icon}`, "tw:mr-1")} />
            {tk &&
                t(
                    tk,
                    productAvailability?.deliveryTime,
                    t(deliveryTimeUnitTk),
                    productAvailability?.realTimeStock
                )}
        </p>
    );
};
